
import './sms-settings.tag'
import './sms-templates.tag'
import './sms-journal.tag'
riot.tag2('sms', '  <ul class="nav nav-tabs m-b-2">\n    <li class="active"><a data-toggle="tab" href="#sms-templates">Шаблоны</a></li>\n    <li><a data-toggle="tab" href="#sms-settings">Настройки</a></li>\n    <li><a data-toggle="tab" href="#sms-journal">Журнал</a></li>\n  </ul>\n  <div class="tab-content">\n    <div class="tab-pane fade in active" id="sms-templates">\n      <sms-templates></sms-templates>\n    </div>\n    <div class="tab-pane fade" id="sms-settings">\n      <sms-settings></sms-settings>\n    </div>\n    <div class="tab-pane fade" id="sms-journal">\n      <sms-journal></sms-journal>\n    </div>\n  </div>\n', '', '', function(opts) {
});


// WEBPACK FOOTER //
// ./pages/settings/sms/sms.tag